import React from "react";
import LegalPage from "../../components/legal-information/LegalPage";
import impressum from "../../content/impressum";

const Impressum = () => {
  return <LegalPage content={impressum} />;
};

export default Impressum;